import type { FailCodeFrequencyEntity } from '../entities';

import { StsBackendOperation } from '../../sts-backend-operation';

/**
 * Parameters for fetching fail code frequencies. A location code is required because frequencies
 * are the second level in the NTF cascade and depend on the selected location.
 */
export type FetchFrequenciesParams = {
    /** The selected location code to fetch frequencies for. */
    locationCode: string;

    /** Optional abort signal to cancel the request. */
    signal?: AbortSignal;
};

/**
 * Fetch fail code frequencies for a selected location. Frequencies are the
 * second-level selection in the no-trouble-found (NTF) cascade used by both
 * QMRs and Techline cases.
 */
export class FetchFrequencies extends StsBackendOperation {
    /**
     * Fetch frequencies from the API and return them as domain entities.
     *
     * @param params - the location code and optional abort signal
     * @returns the frequency entities
     */
    async exec(params: FetchFrequenciesParams): Promise<FailCodeFrequencyEntity[]> {
        const { signal, ...request } = params;

        // Fetch frequencies from the backend
        const response = await this.client.fetchFailCodeFrequencies(request, signal);

        if (!response.success) {
            return [];
        }

        return response.data.frequencies ?? [];
    }
}
